import { render, staticRenderFns } from "./VerticalBlind127mm.vue?vue&type=template&id=3ed8c7fe&scoped=true&"
import script from "./VerticalBlind127mm.vue?vue&type=script&lang=js&"
export * from "./VerticalBlind127mm.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBlind127mm.vue?vue&type=style&index=0&id=3ed8c7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8c7fe",
  null
  
)

export default component.exports